<template>
  <component :is="subComponentName" :model="page"></component>
</template>
<script>
import NewsDetails from '../contentComponents/news/ContentType.NewsDetails.vue'
import VacancyDetails from '../contentComponents/Vacancy/ContentType.VacancyDetails.vue'
import Page from '../app/PageControl.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'SubPageResolver',
  data: () => ({ page: {} }),
  components: {
    NewsDetails,
    VacancyDetails,
    Page
  },
  props: ['pageType'],
  watch: {
    subPage: function () {
      this.load()
    }
  },
  computed: {
    subComponentName: function () {
      return this.pageType
    },
    ...mapGetters({
      subPage: 'subPage'
    })
  },
  methods: {
    load() {
      this.page = {}
      if (this.$store.getters.subPage && this.$store.getters.page.components) {
        this.page = this.$store.getters.subPage
      }
    }
  },
  created() {
    this.load()
  }
}
</script>
